module.exports = __webpack_public_path__ + "img/2_de.8ce49086.jpg";